import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9931bc60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff-info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { style: {"margin":"0.5rem 0"} }
const _hoisted_4 = { class: "staff-service-num" }
const _hoisted_5 = { class: "desc three-hide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "staff-item",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.item_click && _ctx.item_click(...args)))
  }, [
    _createVNode(_component_van_image, {
      radius: "5",
      width: "100px",
      height: "110px",
      src: _ctx.staff.thumb,
      "lazy-load": ""
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.staff.memberName), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "本月服务:" + _toDisplayString(_ctx.staff.serviceNum) + "次", 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.staff.staffIntroduce), 1)
    ])
  ]))
}